import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 30px 100px;
  min-height: calc(100vh - 110px);
`;
